import * as React from 'react';

interface EmptyProps {
  height?: number | string;
  text?: string;
  textStyle?: React.CSSProperties;
}

const Empty = ({ height, text = 'NO DATA', textStyle }: EmptyProps) => {
  let heightProp = 'auto';
  if (typeof height === 'number') {
    heightProp = `${height}px`;
  } else if (typeof height === 'string') {
    heightProp = height;
  }

  return (
    <div className="empty-container" style={{ height: heightProp }}>
      <div className="empty-content">
        <span style={textStyle}>{text}</span>
      </div>
    </div>
  );
};

export default Empty;
